module.exports = __webpack_public_path__ + "img/alert-triangle.80ce467.svg";